import "./import/blocks.js";

$ (function(){

  $('.header__menu__burger, .header__menu__list li a').click(function(){
    $('.header__menu__list').toggleClass('header__menu__list__block')
  });


  $(window).scroll(function() {
    var height = $(window).scrollTop();
    
         /*Если сделали скролл на 100px задаём новый класс для header*/
    if(height > 100){
    $('.header__menu').addClass('header__menu__black');
    } else{
         /*Если меньше 100px удаляем класс для header*/
    $('.header__menu').removeClass('header__menu__black');
    }
    
    });
})